import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, compact = false) {
  if (value == null || isNaN(value)) return '$0';
  if (compact && Math.abs(value) >= 1000000) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      maximumFractionDigits: 1
    }).format(value);
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(value);
}

export function formatNumber(value, decimals = 1) {
  if (value == null || isNaN(value)) return '0';
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: decimals
  }).format(value);
}

export function formatPercent(value) {
  if (value == null || isNaN(value)) return '0.0%';
  return `${Number(value).toFixed(1)}%`;
}

export function getStatusColor(status) {
  switch (status?.toLowerCase()) {
    case 'operational':
    case 'completed':
    case 'online':
      return 'emerald';
    case 'warning':
    case 'scheduled':
    case 'in_progress':
      return 'amber';
    case 'critical':
    case 'overdue':
      return 'red';
    case 'offline':
    case 'pending':
    case 'on_hold':
      return 'slate';
    default:
      return 'slate';
  }
}

export function getPriorityColor(priority) {
  switch (priority?.toLowerCase()) {
    case 'critical':
      return 'red';
    case 'high':
      return 'orange';
    case 'medium':
      return 'amber';
    case 'low':
      return 'slate';
    default:
      return 'slate';
  }
}

export function getAssetTypeIcon(type) {
  switch (type?.toLowerCase()) {
    case 'wind':
      return 'Wind';
    case 'solar':
      return 'Sun';
    case 'battery':
      return 'Battery';
    default:
      return 'Zap';
  }
}

export function timeAgo(date) {
  const now = new Date();
  const past = new Date(date);
  const diffMs = now - past;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return past.toLocaleDateString();
}
